/**
 * Miniature certificate, used inside the feature bento "Verifiable
 * certificates" tile.
 */
export default function CertificateMini() {
  return (
    <div
      className="relative overflow-hidden mt-3.5"
      style={{
        background: 'linear-gradient(180deg, #faf7ef 0%, #fff 100%)',
        border: '2px solid var(--yellow)',
        borderRadius: 8,
        padding: 14,
      }}
    >
      <div className="flex justify-between items-start">
        <div>
          <div className="font-bold tracking-widest" style={{ fontSize: 8, color: 'var(--muted)' }}>CERTIFICATE OF COMPLETION</div>
          <div className="font-serif font-semibold mt-1" style={{ fontSize: 14, color: 'var(--ink)' }}>AI Literacy 101</div>
          <div className="mt-1" style={{ fontSize: 10, color: 'var(--muted-2)' }}>Awarded to A. Saleem</div>
        </div>
        <span
          className="inline-flex items-center justify-center font-serif font-bold"
          style={{ width: 22, height: 22, background: 'var(--yellow)', borderRadius: 3, color: 'var(--navy)', fontSize: 12 }}
        >m</span>
      </div>
      <div className="flex justify-between items-end mt-3.5">
        <div>
          <div style={{ width: 80, height: 1.5, background: 'var(--ink)' }} />
          <div className="mt-0.5" style={{ fontSize: 8, color: 'var(--muted)' }}>Lincoln Method</div>
        </div>
        <svg width="46" height="46" viewBox="0 0 46 46">
          <rect width="46" height="46" fill="#fff" />
          {[[0, 0, 12, 12], [34, 0, 12, 12], [0, 34, 12, 12]].map(([x, y, w, h], i) => (
            <g key={i}>
              <rect x={x} y={y} width={w} height={h} fill="var(--navy)" />
              <rect x={x + 3} y={y + 3} width={w - 6} height={h - 6} fill="#fff" />
              <rect x={x + 5} y={y + 5} width={w - 10} height={h - 10} fill="var(--navy)" />
            </g>
          ))}
          {Array.from({ length: 90 }).map((_, i) => {
            const x = 14 + (i % 10) * 2.4;
            const y = 14 + Math.floor(i / 10) * 2.4;
            return Math.random() > 0.5 ? <rect key={i} x={x} y={y} width={2.2} height={2.2} fill="var(--navy)" /> : null;
          })}
        </svg>
      </div>
    </div>
  );
}
